import type { EWalletType, IMessage } from '@dev-fast/types';

const ACTION_SCOPE = '[Game Messages]';

export class GetDoubleMessages {
  static readonly type = `${ACTION_SCOPE} Get Double Messages`;
  constructor(public walletType: EWalletType) {}
}

export class AddDoubleMessages {
  static readonly type = `${ACTION_SCOPE} Add Chat Message`;

  constructor(public messages: IMessage[]) {}
}

export class GetDoubleJackpotStatusAndSendMessageToChat {
  static readonly type = `${ACTION_SCOPE} Get Double Jackpot Status And Send Message To Chat`;
  constructor(public walletType: EWalletType) {}
}
